<template>
  <q-page padding class="container">
    <div class="row q-gutter-sm">
      <div class="col-xs-12 col-sm-8">
        <p class="text-h6 text-weight-bold text-brand-5 texto-titulo">
          Configuração de Alertas
        </p>
      </div>
    </div>
    <div
      class="row col-12 q-gutter-sm text-brand-5 text-weight-bold q-mt-md container-inputs items-center"
    >
      <div class="col-2">
        <div>Unidade</div>
        <ListaUnidadesSelect />
      </div>
      <div>
        <p></p>
        <q-btn
          label="Criar Alerta"
          color="primary"
          no-caps
          :outline="!rightDrawerModalOpen"
          icon="add"
          class="q-mt-xs"
          @click="rightDrawerModalOpen = true"
        />
      </div>
    </div>

    <div class="q-mt-md">
      <div
        v-if="listaAlertasCriados.length > 0"
        class="row col-12 q-my-xl justify-between items-center"
      >
        <span
          class="texto-titulo-tabela q-ml-md text-brand-5 text-subtitle1 text-weight-bold"
        >
          Lista de Alertas Criados
        </span>
      </div>
      <q-table
        v-if="listaAlertasCriados.length > 0"
        :rows="listaAlertasCriados"
        :columns="columns"
        :loading="loading"
        color="primary"
        class="tabela-tamanho-fixo"
        dense
        table-header-class="bg-accent text-weight-bold"
        flat
        hide-bottom
        :rows-per-page-options="[0]"
      >
        <template v-slot:body="props">
          <q-tr class="text-brand-5 text-weight-bold" :props="props">
            <q-td>
              {{ props.row.entidade }}
            </q-td>
            <q-td>
              <div
                :style="
                  props.row.app == true
                    ? 'background: #e8ffec; width: fit-content; padding: 0px 5px'
                    : 'background:#ffe9e9; color: #850202; width: fit-content; padding: 0px 5px'
                "
                class="row items-center"
              >
                <div
                  v-if="props.row.app == true"
                  class="elipse q-mr-xs bg-positive"
                ></div>
                <div
                  v-else
                  class="elipse q-mr-xs"
                  style="background: red"
                ></div>
                <span
                  v-if="props.row.app == true"
                  class="row justify-center text-brand-5"
                >
                  Habilitado
                </span>
                <span v-else class="row justify-center text-brand-5">
                  Desabilitado
                </span>
              </div>
            </q-td>
            <q-td>
              <div
                :style="
                  props.row.email == true
                    ? 'background: #e8ffec; width: fit-content; padding: 0px 5px'
                    : 'background:#ffe9e9; color: #850202; width: fit-content; padding: 0px 5px'
                "
                class="row items-center"
              >
                <div
                  v-if="props.row.email == true"
                  class="elipse q-mr-xs bg-positive"
                ></div>
                <div
                  v-else
                  class="elipse q-mr-xs"
                  style="background: red"
                ></div>
                <span
                  v-if="props.row.email == true"
                  class="row justify-center text-brand-5"
                >
                  Habilitado
                </span>
                <span v-else class="row justify-center text-brand-5">
                  Desabilitado
                </span>
              </div>
            </q-td>
            <q-td>
              {{ props.row.matricula }}
            </q-td>
            <q-td>
              <div
                :style="
                  props.row.habilitado == true
                    ? 'background: #e8ffec; width: fit-content; padding: 0px 5px'
                    : 'background:#ffe9e9; color: #850202; width: fit-content; padding: 0px 5px'
                "
                class="row items-center"
              >
                <div
                  v-if="props.row.habilitado == true"
                  class="elipse q-mr-xs bg-positive"
                ></div>
                <div
                  v-else
                  class="elipse q-mr-xs"
                  style="background: red"
                ></div>
                <span
                  v-if="props.row.habilitado == true"
                  class="row justify-center text-brand-5"
                >
                  Habilitado
                </span>
                <span v-else class="row justify-center text-brand-5">
                  Desabilitado
                </span>
              </div>
            </q-td>
            <q-td>
              <div class="q-ml-lg" v-if="props.row.habilitado">
                <q-btn
                  icon="notifications_off"
                  flat
                  color="red"
                  round
                  @click="habilitarDesabilitarAlerta(props.row, false)"
                />
              </div>
              <div class="q-ml-lg" v-else>
                <q-btn
                  icon="add_alert"
                  flat
                  round
                  color="positive"
                  @click="habilitarDesabilitarAlerta(props.row, true)"
                />
              </div>
            </q-td>
          </q-tr>
        </template>
      </q-table>
      <div
        class="text-brand-5 text-weight-bold"
        style="font-size: 18px; margin-top: 100px"
        v-else
      >
        Nenhum alerta criado
      </div>
    </div>
    <Transition name="slide-fade">
      <q-card v-if="rightDrawerModalOpen" class="drawer-modal">
        <div class="row q-pa-md text-weight-bold">
          <div class="row col-12 items-center">
            <div class="row">
              <q-icon
                style="cursor: pointer"
                name="close"
                class="q-mr-md"
                size="22px"
                @click="rightDrawerModalOpen = false"
              />
              <span style="font-size: 16px">
                <span>
                  <span>Criar Alerta</span>
                </span>
              </span>
            </div>
          </div>
        </div>
        <div class="row col-12 q-mb-md q-mx-sm">
          <q-tabs indicator-color="black" v-model="tab" class="row text-teal">
            <q-tab
              name="grupo"
              class="text-black"
              label="Criar Alerta para Grupo"
              no-caps
            />
            <q-tab
              class="text-black"
              name="subgrupo"
              no-caps
              label="Criar Alerta para subGrupo"
            />
            <q-tab
              class="text-black"
              name="catalogo"
              no-caps
              label="Criar Alerta para Catalogo"
            />
          </q-tabs>
        </div>
        <q-scroll-area v-if="tab == 'grupo'" style="width: 100%; height: 100%">
          <div class="column col-12 no-wrap">
            <div class="q-px-md text-weight-bold">
              <div class="col">
                <span>Grupo</span>
                <q-select
                  v-model="grupo"
                  :options="listaGrupos"
                  dense
                  outlined
                  class="select input-new-design"
                  use-input
                  option-label="nome"
                  option-value="id"
                  input-debounce="0"
                  @filter="filterGrupo"
                />
              </div>
              <div v-if="listaTipos != null" class="col q-mt-md">
                <span
                  >Tipos Vinculados a categoria: {{ listaTipos.total }}</span
                >
              </div>
              <div class="col q-mt-md">
                <span>Tipo de Alerta</span>
                <div class="q-gutter-sm">
                  <q-checkbox
                    v-model="alerta.sistema"
                    :val="true"
                    label="Sistema"
                    checked-icon="radio_button_checked"
                    unchecked-icon="radio_button_unchecked"
                    size="lg"
                  />
                  <q-checkbox
                    v-model="alerta.email"
                    :val="true"
                    :disable="true"
                    label="Email"
                    checked-icon="radio_button_checked"
                    unchecked-icon="radio_button_unchecked"
                    size="lg"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="col q-mt-lg">
            <div class="row justify-end q-mx-md">
              <p></p>
              <q-btn
                @click="criarAlerta('categoria', categoria?.uuid)"
                label="Criar Alerta"
                no-caps
                color="positive"
                dense
                icon="check_circle_outline"
              />
            </div>
          </div>
        </q-scroll-area>
        <q-scroll-area
          v-if="tab == 'subgrupo'"
          class="teste"
          style="width: 100%; height: 92%"
        >
          <div class="column col-12 no-wrap">
            <div class="q-px-md text-weight-bold">
              <div class="col">
                <span>Grupo</span>
                <q-select
                  v-model="grupo"
                  :options="listaGrupos"
                  dense
                  outlined
                  class="select input-new-design q-mb-sm"
                  use-input
                  option-label="nome"
                  option-value="id"
                  input-debounce="0"
                  @filter="filterGrupo"
                />
                <span>SubGrupo</span>
                <q-select
                  v-model="subGrupo"
                  :options="listaSubGrupos"
                  :disable="grupo"
                  dense
                  outlined
                  class="select input-new-design"
                  option-label="nome"
                  option-value="id"
                />
              </div>

              <div class="col q-mt-md">
                <span>Tipo de Alerta</span>
                <div class="q-gutter-sm">
                  <q-checkbox
                    v-model="alerta.sistema"
                    :val="true"
                    label="Sistema"
                    checked-icon="radio_button_checked"
                    unchecked-icon="radio_button_unchecked"
                    size="lg"
                  />
                  <q-checkbox
                    v-model="alerta.email"
                    :val="true"
                    :disable="true"
                    label="Email"
                    checked-icon="radio_button_checked"
                    unchecked-icon="radio_button_unchecked"
                    size="lg"
                  />
                </div>
              </div>
            </div>
            <div class="col q-mt-lg">
              <div class="row justify-end q-mx-md">
                <p></p>
                <q-btn
                  @click="criarAlerta('tipo', tipo?.uuid)"
                  label="Criar Alerta"
                  no-caps
                  color="positive"
                  dense
                  icon="check_circle_outline"
                />
              </div>
            </div>
          </div>
        </q-scroll-area>
        <q-scroll-area
          v-if="tab == 'catalogo'"
          class="teste"
          style="width: 100%; height: 92%"
        >
          <div class="column col-12 no-wrap">
            <div class="q-px-md text-weight-bold">
              <div class="col">
                <span>Catalogo</span>
                <q-select
                  v-model="catalogo"
                  :options="listaCatalogo"
                  dense
                  outlined
                  class="select input-new-design q-mb-sm"
                  option-label="nome"
                  option-value="id"
                  @filter="filterCatalogo"
                />
              </div>

              <div class="col q-mt-md">
                <span>Tipo de Alerta</span>
                <div class="q-gutter-sm">
                  <q-checkbox
                    v-model="alerta.sistema"
                    :val="true"
                    label="Sistema"
                    checked-icon="radio_button_checked"
                    unchecked-icon="radio_button_unchecked"
                    size="lg"
                  />
                  <q-checkbox
                    v-model="alerta.email"
                    :disable="true"
                    :val="true"
                    label="Email"
                    checked-icon="radio_button_checked"
                    unchecked-icon="radio_button_unchecked"
                    size="lg"
                  />
                </div>
              </div>
            </div>
            <div class="col q-mt-lg">
              <div class="row justify-end q-mx-md">
                <p></p>
                <q-btn
                  @click="criarAlerta"
                  label="Criar Alerta"
                  no-caps
                  color="positive"
                  dense
                  icon="check_circle_outline"
                />
              </div>
            </div>
          </div>
        </q-scroll-area>
      </q-card>
    </Transition>
    <div
      v-if="rightDrawerModalOpen"
      @click="rightDrawerModalOpen = false"
      class="mascara"
    ></div>
  </q-page>
</template>

<script setup>
const columns = [
  {
    name: "entidade",
    label: "Entidade",
    align: "left",
    field: "entidade",
  },
  {
    name: "sistema",
    label: "Sistema",
    align: "left",
    field: "app",
  },
  {
    name: "email",
    label: "Email",
    align: "left",
    field: "email",
  },
  {
    name: "criadoPor",
    label: "matricula",
    align: "left",
  },
  {
    name: "habilitado",
    label: "Habilitado",
    align: "left",
  },
  {
    name: "habilitadoDesabilitado",
    label: "Habilitar/Desabilitar",
    align: "left",
  },
];
import { onMounted, ref, watch } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";

import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import { salvarCatalogoUuid } from "../composables/salvarCatalogoUuid";

const store = useStore();
const quasar = useQuasar();

const tab = ref("grupo");
let rightDrawerModalOpen = ref(false);
const categoria = ref("");
const tipo = ref("");
const catalogoUuid = salvarCatalogoUuid();
const listaTipos = ref(null);
const listaGrupos = ref(null);
const listaCatalogo = ref(null);
const listaSubGrupos = ref(null);
const time = ref();
const grupo = ref("");
const subGrupo = ref(null);
const catalogo = ref(null);
const alerta = ref({
  sistema: true,
  email: false,
});
const unidade = ref({
  nome: store.state.org.unidadeData.nome,
  id: store.state.org.unidadeData.id,
  logo: store.state.org.unidadeData.logo,
});
const listaAlertasCriados = ref([]);
const optionsUnidade = ref([]);
let loading = ref(false);

const listarAlertas = async () => {
  try {
    loading.value = true;
    const response = await store.dispatch("ferramentaria/listarAlertasCriados");
    listaAlertasCriados.value = response.data.resultado.message;
    loading.value = false;
  } catch (error) {
    console.log(error);
  }
};
const listarGrupos = async (val) => {
  try {
    await store.state.org.unidadeData.id;
    if (catalogoUuid.catalogoUuid.value === null) {
      listaGrupos.value = [];
      return;
    }
    const response = await store.dispatch("ferramentaria/listarGruposCriados", {
      catalogoUuid: catalogoUuid.catalogoUuid.value,
      unidadeId: store.state.org.unidadeData.id,
      nome: val,
      per_page: 5,
    });
    listaGrupos.value = response.data.resultado.dados;
  } catch (error) {
    console.log(error);
  }
};

const listarSubGrupos = async (val) => {
  try {
    const response = await store.dispatch("ferramentaria/listarSubgrupoGrupo", {
      catalogoGrupoUuid: grupo.value.catalogoGrupoUuid,
      perPage: 5,
      nome: val,
    });
    listaSubGrupos.value = response.data.resultado.dados;
  } catch (error) {
    console.log(error);
  }
};

const listarCatalogo = async (val) => {
  await store.state.org.unidadeData.id;

  try {
    const response = await store.dispatch("ferramentaria/listarCatalogo", {
      unidadeId: store.state.org.unidadeData.id,
      nome: val,
    });
    listaCatalogo.value = response.response.data.resultado.dados;
  } catch (error) {
    console.log(error);
  }
};

const listarTipos = async () => {
  try {
    const response = await store.dispatch("documento/listarTipos", {
      unidadeId: store.state.org.unidadeData.id,
      categoriaUuid: categoria.value.uuid,
      perPage: 100,
    });
    listaTipos.value = response.data.resultado;
  } catch (error) {
    console.log(error);
  }
};

const criarAlerta = async () => {
  try {
    await store.dispatch("ferramentaria/criarAlerta", {
      entidade: tab.value,
      entidadeUuid: await getEntity(tab.value),
      app: true,
      email: false,
      habilitado: true,
    });

    listarAlertas();
    rightDrawerModalOpen.value = false;
    quasar.notify({
      message: "Alerta criado com sucesso.",
      color: "positive",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  } catch (error) {
    quasar.notify({
      message: "Erro ao criar alerta.",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  }
};

const habilitarDesabilitarAlerta = async (alerta, acao) => {
  try {
    await store.dispatch("ferramentaria/criarAlerta", {
      entidade: alerta.entidade,
      entidadeUuid: alerta.entidadeUuid,
      app: alerta.app,
      email: alerta.email,
      habilitado: acao,
    });
    listarAlertas();
    if (acao) {
      quasar.notify({
        message: "Alerta habilitado com sucesso.",
        color: "positive",
        actions: [
          {
            label: "Fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
    } else {
      quasar.notify({
        message: "Alerta desabilitado com sucesso.",
        color: "positive",
        actions: [
          {
            label: "Fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
    }
  } catch (error) {
    if (acao) {
      quasar.notify({
        message: "Erro ao habilitar alerta.",
        color: "negative",
        actions: [
          {
            label: "Fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
    } else {
      quasar.notify({
        message: "Erro ao desabilitar alerta.",
        color: "negative",
        actions: [
          {
            label: "Fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
    }
  }
};

const getEntity = async (tipo) => {
  switch (tipo) {
    case "grupo":
      return grupo.value.catalogoGrupoUuid;

    case "subgrupo":
      return subGrupo.value.catalogoSubGrupoUuid;
    case "catalogo":
      return catalogo.value.catalogoUuid;
  }
};

const listarUnidades = async () => {
  try {
    const response = await store.dispatch("org/listarUnidades");
    optionsUnidade.value = response.listaUnidades;
    unidade.value = {
      nome: store.state.org.unidadeData.nome,
      id: store.state.org.unidadeData.id,
      logo: store.state.org.unidadeData.logo,
    };
  } catch (error) {
    console.log(error);
  }
};

watch(
  () => categoria.value?.uuid,
  () => {
    if (categoria.value?.uuid) {
      listarTipos();
      return;
    }
    listaTipos.value = null;
  }
);
watch(
  () => store.state.org.unidadeData.id,
  () => {
    listarAlertas();
  }
);
watch(
  () => tab.value,
  () => {
    listaTipos.value = null;
    categoria.value = "";
    tipo.value = "";
    alerta.value = {
      sistema: true,
      email: false,
    };
  }
);

watch(
  () => grupo.value,
  () => {
    listarSubGrupos();
  }
);

onMounted(() => {
  listarAlertas();
  listarUnidades();
  listarGrupos();
  listarCatalogo();
});

const filterGrupo = (val, update, abort) => {
  clearTimeout(time.value);
  if (val.length < 1) {
    abort();
    return;
  }

  time.value = setTimeout(() => {
    listarGrupos(val);
  }, 2000);

  setTimeout(() => {
    update();
  }, 2500);
};

/*const filterCatalogo = (val, update, abort) => {
  clearTimeout(time.value);
  if (val.length < 1) {
    abort();
    return;
  }

  time.value = setTimeout(() => {
    listarCatalogo(val);
  }, 2000);

  setTimeout(() => {
    update();
  }, 2500);
};*/
</script>

<style scoped>
.container {
  height: 100%;
}
.drawer-modal {
  border: 2px solid black;
  position: absolute;
  right: 0;

  position: fixed;
  top: 106px;
  height: calc(100% - 10px);
  max-height: 650px;
  border-radius: 10px 1px 1px 10px;
  margin: 2px;
  z-index: 3;
}
.slide-fade-enter-active {
  transition: all 0.5s ease-out;
}
.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(400px);
}
.mascara {
  background-color: black;
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  opacity: 0.4;
}
.card {
  border: 1px solid #707070;
  border-radius: 5px;
}
.text-grid-table {
  font-size: 18px;
}
.elipse {
  width: 12px;
  height: 12px;
  border-radius: 100%;
}
@media (max-width: 1200px) {
  .drawer-modal {
    max-height: 85%;
  }
}
@media (max-width: 900px) {
  .drawer-modal {
    max-height: 80%;
    top: 118px;
  }
}
@media (max-width: 600px) {
  .drawer-modal {
    max-height: 80%;
    top: 107px;
  }
}
</style>
